import { useEffect, useRef, useState } from "react";
import { Loader2 } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";

export type SpinnerText = string[];

export interface SpinnerProps {
	messages?: SpinnerText;
	intervalMs?: number;
	className?: string; // wrapper (layout)
	size?: number; // loader icon size
	messageClassName?: string; // text style
	loaderClassName?: string; // NEW: override loader color/style
}

const defaultMessages = ["Loading..."];

export const Spinner = ({
	messages = defaultMessages,
	intervalMs = 4000,
	className = "",
	size = 40,
	messageClassName = "text-primary opacity-70 text-center",
	loaderClassName = "text-white opacity-90",
}: SpinnerProps) => {
	const [index, setIndex] = useState(0);
	const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

	useEffect(() => {
		if (messages.length <= 1) return;

		intervalRef.current = setInterval(() => {
			setIndex(prev => (prev + 1) % messages.length);
		}, intervalMs);

		return () => {
			if (intervalRef.current) clearInterval(intervalRef.current);
		};
	}, [messages, intervalMs]);

	return (
		<div className={`flex flex-col items-center justify-center ${className}`}>
			<Loader2 className={`animate-spin ${loaderClassName}`} style={{ width: size, height: size }} />
			{messages.length > 0 && (
				<AnimatePresence mode="wait">
					<motion.p
						key={index}
						initial={{ opacity: 0, y: 6 }}
						animate={{ opacity: 1, y: 0 }}
						exit={{ opacity: 0, y: -6 }}
						transition={{ duration: 0.5 }}
						className={`mt-1 text-sm ${messageClassName}`}
					>
						{messages[index]}
					</motion.p>
				</AnimatePresence>
			)}
		</div>
	);
};
